// extracted by mini-css-extract-plugin
export default {"walletContainer":"style_walletContainer__pt9Js","loadMoreButton":"style_loadMoreButton__EJsYx"};